import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SequenceDataModel } from './sequence-data.model';

export class OperationSequenceResponseModel extends GlobalResponseObject{
    data?: SequenceDataModel[] ;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SequenceDataModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 